const cookiesPopup = document.querySelector('.cookies');
const closeCookies = cookiesPopup.querySelector('.cookies__cross');
const setCookies = cookiesPopup.querySelector('.cookies__button');

function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) {
		return parts.pop().split(';').shift();
	}

	return '';
}

if (getCookie('cookieconsent') !== '1') {
	cookiesPopup.classList.remove('hidden');
}

closeCookies.addEventListener('click', () => cookiesPopup.classList.add('hidden'));

setCookies.addEventListener('click', () => {
	const expiry = new Date();
	expiry.setTime(expiry.getTime()+(365*24*60*60*1000));
	document.cookie = 'cookieconsent=1; expires=' + expiry.toGMTString();
	cookiesPopup.classList.add('hidden');
});

